import { Box } from '@mui/material';
import { FsButton } from '../../../../../../shared/components/button';
import { useTranslation } from 'react-i18next';
import { DialogWrapper } from '../../../../../../shared/components/common/dialogWrapper';
import { TextWrapper } from '../../../../../../shared/components/formUtilities/useTextWrapper';
import { currencyFormatterHelper } from '../../../../../../helpers/currencyFormatterHelper';
import { CURRENCY } from '../../../../../../config/appConfig';
import { useEffect } from 'react';
import { LocalStorageKey } from '../../../../../../constants/localStorageKeys';

export const InvestSuccessDialog = ({
	state,
	onClose = (e) => { },
	amount = 0,
	couponDetails = null
}) => {
	const { t } = useTranslation();

	const getAmount = () => {
		if (couponDetails) {
			return currencyFormatterHelper(couponDetails?.totalInvestedAmount);
		}

		return currencyFormatterHelper(amount);
	};

	useEffect(() => {
		if (couponDetails && couponDetails?.code) {
			const isFirstGain = couponDetails?.code?.includes('FirstGain');
			if (isFirstGain) {
				localStorage.setItem(LocalStorageKey.firstGainApplied, "1");
			}
		}
	}, [couponDetails]);
	return (
		<DialogWrapper
			hideCloseBtn={true}
			maxWidth="xs"
			width={'380px'}
			state={state}
			onClose={() => {
				onClose(false);
			}}
			content={
				<>
					<Box className="grid grid-flow-row gap-4 invest-success justify-center relative">
						<Box className="flex justify-center">
							<svg
								viewBox="0 0 26 26"
								xmlns="http://www.w3.org/2000/svg">
								<g
									stroke="currentColor"
									stroke-width="2"
									fill="none"
									fill-rule="evenodd"
									stroke-linecap="round"
									stroke-linejoin="round">
									<path
										class="circle"
										d="M13 1C6.372583 1 1 6.372583 1 13s5.372583 12 12 12 12-5.372583 12-12S19.627417 1 13 1z"
									/>
									<path
										class="tick"
										d="M6.5 13.5L10 17 l8.808621-8.308621"
									/>
								</g>
							</svg>
						</Box>
						<Box className="flex justify-center items-center">
							<TextWrapper
								classList="!font-bold !sub-heading !text-center"
								text={t('thankYouInvestAgain')}></TextWrapper>
						</Box>
						<Box className="text-center">
							<TextWrapper
								classList="!sub-title-text"
								text={t('thankYouInvestAgainBody')}></TextWrapper>
							<TextWrapper
								classList="!sub-title-text !font-bold"
								text={`${CURRENCY} ${getAmount()}.`}></TextWrapper>
							<TextWrapper
								classList="!sub-title-text"
								text={t('thankYouInvestAgainBody1')}></TextWrapper>
						</Box>
						{couponDetails ? <Box className='mt-3 mb-4 space-y-2'>
							<Box className='flex items-center justify-between !text-[12px] border-b py-1'>
								<Box>{t('amount')}</Box>
								<Box className="font-[500]">{`${CURRENCY} ${currencyFormatterHelper(amount)}`}</Box>
							</Box>
							{couponDetails ? <Box className='flex items-center justify-between !text-[12px] border-b py-1'>
								<Box>{t('couponApplied')}</Box>
								<Box className="font-[500]">
									(+) {`${CURRENCY} ${currencyFormatterHelper(couponDetails?.cashbackAmount)}`}</Box>
							</Box> : null}
							{couponDetails ? <Box className='flex items-center justify-between !text-[12px]'>
								<Box>{t('total')}</Box>
								<Box className="font-[500]">{`${CURRENCY} ${currencyFormatterHelper(couponDetails?.totalInvestedAmount)}`}</Box>
							</Box> : null}
							{couponDetails ? <Box className='!text-[11px] caption relative top-3'>
								{t('cashbackTermsConditions')}
							</Box> : null}
						</Box> : null}
					</Box>
				</>
			}
			actions={
				<Box className="flex items-center">
					<FsButton
						variant="green"
						onClick={() => {
							onClose(false);
						}}>{t('ok')}</FsButton>
				</Box>
			}></DialogWrapper>
	);
};
